/**
 * @generated SignedSource<<19a37185adc29bab5fb7d2f13f25eece>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastDeviceItem_StorecastScreen$data = {
  readonly activeSession: {
    readonly id: string;
    readonly latencyMs: number | null;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "StorecastDeviceItem_StorecastScreen";
};
export type StorecastDeviceItem_StorecastScreen$key = {
  readonly " $data"?: StorecastDeviceItem_StorecastScreen$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastDeviceItem_StorecastScreen">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastDeviceItem_StorecastScreen",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastSession",
      "kind": "LinkedField",
      "name": "activeSession",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "latencyMs",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};

(node as any).hash = "d3a95c264f3829768cb857007d3dba9e";

export default node;
